import { render, staticRenderFns } from "./ModalPromotion.vue?vue&type=template&id=09539ebe&"
import script from "./ModalPromotion.vue?vue&type=script&lang=js&"
export * from "./ModalPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports